'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  users: {
    accessRights: {
      calendars: 'Calendriers',
      hideInheritedRights: 'Cacher les droits hérités',
      organizations: 'Organisations',
      showInheritedRights: 'Afficher les droits hérités',
      title: "Droits d'accès"
    },
    attributes: {
      email: 'Courriel',
      password: 'Mot de passe'
    },
    empty: 'Aucun utilisateur.',
    form: {
      confirmSave: 'Voulez-vous enregistrer les modifications \xE0 cet utilisateur\xA0?',
      dontSave: 'Ne pas enregistrer'
    },
    invite: {
      button: 'Inviter un utilisateur',
      messagePlaceholder: 'Message optionnel',
      save: 'Inviter',
      text: "L'utilisateur sera invité sur"
    },
    next: 'Page suivante',
    new: 'Ajouter un utilisateur',
    previous: 'Page précédente',
    sortDirection: {
      asc: 'en ordre croissant',
      desc: 'en ordre décroissant'
    },
    sortOrder: {
      creation: 'date de création',
      email: 'courriel',
      modification: 'date de mise à jour',
      name: 'nom'
    },
    title: 'Utilisateurs',
    titleBox: {
      help: "Nom de l'utilisateur"
    },
    total: '%{smart_count} utilisateur classé par |||| %{smart_count} utilisateurs classés par'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/users.js
// module id = 2298
// module chunks = 0